module.exports = __webpack_public_path__ + "img/twitter.dc6d012f.svg";